<div class="container">
  <mat-card-title class="mat-card-title">User Details</mat-card-title>
  <hr class="horizontal-line">
  <div fxLayout="row" *ngIf="pageLoaded" class="card-container">
    <div fxFlex="30" class="user-div">
      <div class="profile-icon" fxLayout="column">
        <i class="material-icons">person</i>
        <h1>{{capitalizeFirstLetter(user?.name) }}</h1>
      </div>

      <hr class="horizontal-line">

      <div class="user-detail">
        <div class="detail-label">User ID</div>
        <div id="user-id" class="ng-binding" *ngIf="user?.id">{{ user.id }}</div>
      </div>

      <div class="user-detail">
        <div class="detail-label">Verified Email</div>
        <div id="user-email" *ngIf="user?.verified_email">
          <a href="mailto:{{ user.verified_email }}" class="ng-binding">{{ user.verified_email }}</a>
        </div>
      </div>

      <div class="user-detail" *ngIf="user?.pending_email && user?.pending_email !== user?.verified_email">
        <div class="detail-label">Pending Email</div>
        <div id="user-pending-email" class="ng-binding">{{ user.pending_email }}</div>
      </div>

      <div class="user-detail">
        <div class="detail-label">Registered</div>
        <div id="user-registration-time">
          <span *ngIf="user?.created">{{ user.created | date: dateFormat }}</span>
          <span *ngIf="!user?.created">N/A</span>
        </div>
      </div>

      <div class="user-detail">
        <div class="detail-label">Notifications</div>
        <div id="user-notify-methods" class="ng-binding" *ngIf="user?.notify">{{ user.notify }}</div>
      </div>

      <div class="user-detail">
        <div class="detail-label">Alexa Enabled</div>
        <div id="user-alexa-enabled" class="ng-binding" *ngIf="user?.alexaenabled">{{ user.alexaenabled }}</div>
      </div>

      <div class="user-detail" *ngIf="user?.SubscriptionActive">
        <div class="detail-label">Subscription Status</div>
        <div id="user-subscription-status" class="ng-binding">{{ user?.SubscriptionActive }}</div>
      </div>

      <div class="user-detail" *ngIf="user?.SubscriptionActive">
        <div class="detail-label">Subscription Expiry Date</div>
        <div id="user-subscription-expiry-date" class="ng-binding">{{ user?.SubscriptionExpiresDate | date: dateFormat
          }}</div>
      </div>

      <div class="user-detail" *ngIf="user?.SubscriptionActive">
        <div class="detail-label">Subscription Biller</div>
        <div id="user-subscription-biller" class="ng-binding">{{ user?.biller }}</div>
      </div>

      <div class="user-detail" *ngIf="user?.SubscriptionActive">
        <div class="detail-label">Subscription Product ID</div>
        <div id="user-subscription-product-id" class="ng-binding">{{ user?.ProductId }}</div>
      </div>

      <div class="user-detail" *ngIf="user?.SubscriptionActive">
        <div class="detail-label">Subscription Type</div>
        <div id="user-subscription-type" class="ng-binding">{{ getSubscriptionType(user?.ProductId) }}</div>
      </div>

      <button *ngIf="user?.SubscriptionActive" class="mat-button-next" mat-raised-button
        (click)="showDeferPopup()">Defer Subscription</button>
      <button *ngIf="user?.OriginalTransactionID" class="mat-button-next" mat-raised-button
        (click)="navigateToSubscriptionHistory()">Subscription History</button>
    </div>


    <div class="device-div" fxFlex="75" fxLayout="column">
      <app-devices-display></app-devices-display>

      <app-location-display></app-location-display>

      <app-device-type></app-device-type>
    </div>
  </div>
</div>